import {
  ChatPage,
  DispatcheMainPage,
  DispatchesDetailsPage,
  CustomerMainPage,
  CustomerDetailsPage,
  DriversMainPage,
  PersonalDetailsPage,
  JobHistoryMainPage,
  AccountingMainPage,
  AgentsMainPage,
} from "../pages";

// Define an array of routes and their required abilities
export const protectedRoutes = [
  { path: "/admin/chat", component: ChatPage, requiredAbility: "Chats" },
  {
    path: "/admin/dispatches",
    component: DispatcheMainPage,
    requiredAbility: "Dispatches",
  },
  {
    path: "/admin/dispatche-details/:id",
    component: DispatchesDetailsPage,
    requiredAbility: "Dispatches",
  },
  {
    path: "/admin/customers",
    component: CustomerMainPage,
    requiredAbility: "Customers",
  },
  {
    path: "/admin/customer-details/:id",
    component: CustomerDetailsPage,
    requiredAbility: "Customers",
  },
  {
    path: "/admin/drivers",
    component: DriversMainPage,
    requiredAbility: "Drivers",
  },
  {
    path: "/admin/drivers/personal-details/:id",
    component: PersonalDetailsPage,
    requiredAbility: "Drivers",
  },
  {
    path: "/admin/job-history",
    component: JobHistoryMainPage,
    requiredAbility: "Job Histories",
  },
  {
    path: "/admin/accounting",
    component: AccountingMainPage,
    requiredAbility: "Accountings",
  },
  {
    path: "/admin/agents",
    component: AgentsMainPage,
    requiredAbility: "Agents",
  },
];
